import * as React from "react";

import { AppBar, Box, CssBaseline, IconButton, Toolbar, Tooltip, Typography } from "@mui/material";
import ModeNightRoundedIcon from '@mui/icons-material/ModeNightRounded';
import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';

import { useNavigate, useLocation, Link } from "react-router-dom";
import { useProfile } from "../../common/useProfile";
import HtmlContentPage from "./HtmlContentPage";
import EditarPaginaHtml from "../editar/EditarPaginaHtml";
import LayoutLeft from "./LayoutLeft";
import MenuComp from "../../util/MenuComp";
import VerticalMenuPage from "./VerticalMenuPage";
import MySpaceComp from "./comps/MySpaceComp";
import NotificationComp from "./comps/notificacao/NotificationComp";
import MainMenuComp from "./comps/MainMenuComp";
import Service from "../../../util/Service";
import { getDeviceType } from "../../../util/Utilitarios";

export default function CodeContentPage(props) {
    const { pageRoot, bloco, darkMode, handleDarkMode, edit, pagina, style } = props;
    const data = bloco.data || {};
    const prof = useProfile();
    const navigate = useNavigate();
    const location = useLocation();
    const accessToken = localStorage.getItem("accessToken");
    const [hasNotificacao, setHasNotificacao] = React.useState(false);

    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const [openD, setOpenD] = React.useState(false);
    const [openEditar, setOpenEditar] = React.useState(false);

    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
    React.useEffect(() => {
        checkExisteNotificacao();
    }, [])

    function checkExisteNotificacao(){
        Service.GET("/api/info/hasNotificacao").then(r=> setHasNotificacao(r));
    }
    const handleDrawerOpen = () => {
        setOpenD(true);
    };
    
    if (bloco.type === "paragraph") {
        return (
            <Box sx={{ display: 'flex' }}>
                <Typography> {bloco.data.text}</Typography>
            </Box>
        )
    }
    if (bloco.type === "raw") {
        return (
            <HtmlContentPage htmlString={bloco.data.html} />
        )
    }
    if (bloco.type === 'verticalMenu') {
        
        return (
            <VerticalMenuPage menu={bloco.data} />
        )
    }
    if (bloco.type === 'appBar') {
        function handleLogin() {
            localStorage.setItem("page", location.pathname);
            navigate("/login");
        }
        function handleLogout() {            
            // localStorage.removeItem("accessToken");
            // localStorage.removeItem("pageRoot");
            localStorage.clear();
            // sessionStorage.removeItem("profile");
            // sessionStorage.removeItem("menu");
            sessionStorage.clear();

            navigate("/");
            window.location.href = "/";
        }
        function MontaLoginLogout(tyle) {
            if (accessToken) {
                return (
                    <Tooltip title="Logout">
                        <IconButton
                            size="small"
                            aria-label=""
                            color="inherit"
                            onClick={handleLogout}
                        // sx={style != null? style:{ }}
                        >
                            <LogoutIcon />
                        </IconButton>
                    </Tooltip>
                )
            } else {
                return (
                    <Tooltip title="Login">
                        <IconButton
                            size="small"
                            aria-label=""
                            color="inherit"
                            onClick={handleLogin}
                            sx={style != null ? style : {}}
                        >
                            <LoginIcon />
                        </IconButton>
                    </Tooltip>
                )
            }
        }
        function showTituloMobile(){
            const titulo = data.titulo;
            const startWithTag = titulo.charAt(0) === '<';
            const endsWithTag = titulo.charAt(titulo.length - 1) === '>';
            
            return (
                <React.Fragment>
                    <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 0 }} />
                <Typography
                variant="h6"
                noWrap
                component="a"
                href="/"
                sx={{
                  mr: 2,
                  display: { xs: 'flex', md: 'none', justifyContent:'end' },
                  flexGrow: 1,
                  fontFamily: 'monospace',
                  //fontWeight: 700,
                  letterSpacing: '.1rem',
                  color: 'inherit',
                  textDecoration: 'none'
                }}
                >
                    {(startWithTag && endsWithTag) ? <span dangerouslySetInnerHTML={{ __html: titulo }} /> : data.titulo}
                </Typography>
                </React.Fragment>
            )
        }
        function showTitulo() {
            const titulo = data.titulo;
            const startWithTag = titulo.charAt(0) === '<';
            const endsWithTag = titulo.charAt(titulo.length - 1) === '>';
            // if (startWithTag && endsWithTag) {
            //     return (
            //         <a dangerouslySetInnerHTML={{ __html: titulo }}
            //             href="/"
            //         />
            //     )
            // }            
            return (
                <Typography
                    variant="h6"
                    noWrap
                    component={Link}
                    to="/"
                    sx={{
                        mr: 2,
                        display: { xs: 'none', md: 'flex' },
                        fontFamily: 'monospace',
                        fontWeight: 700,
                        letterSpacing: '.1rem',
                        color: 'inherit',
                        textDecoration: 'none',
                    }}
                >
                    {(startWithTag && endsWithTag) ? <span dangerouslySetInnerHTML={{ __html: titulo }}
                        href="/"
                    /> : data.titulo}
                </Typography>
            )
        }
        return (
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar
                    position="static"
                    // color="transparent" 
                    sx={style}
                    key={"appBar-2"}
                >
                    <Toolbar variant={data.denseMode?"dense":"regular"}>
                        <MainMenuComp
                            item={bloco} action={handleDrawerOpen}
                        //style={style}
                        />                        
                        {showTitulo()}
                        {showTituloMobile()}
                        <Box sx={{ flexGrow: 1 }} />
                            <MenuComp
                                nomePagina={data.headerMenu} edit={edit} darkMode={darkMode}
                            />
                        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                            {data.profile &&
                                <React.Fragment>
                                    {getDeviceType() ==='desktop' && hasNotificacao && 
                                    <NotificationComp/>}
                                    <MySpaceComp/>
                                </React.Fragment>}

                            {data.login &&
                                MontaLoginLogout(style)
                            }
                            {data.darkMode === true && <Tooltip title={darkMode ? 'Modo Claro' : 'Mode Escuro'}>
                                <IconButton
                                    size="small"
                                    aria-label=""
                                    color="inherit"
                                    onClick={handleDarkMode}                                
                                >
                                    {darkMode ? <WbSunnyRoundedIcon /> : <ModeNightRoundedIcon />}
                                </IconButton>
                            </Tooltip>}
                        </Box>
                        <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 0 }} >
                            {/* {data.login &&
                                MontaLoginLogout(style)
                            } */}
                            {/* {data.darkMode === true && <Tooltip title={darkMode ? 'Modo Claro' : 'Mode Escuro'}>
                                <IconButton
                                    size="small"
                                    aria-label=""
                                    color="inherit"
                                    onClick={handleDarkMode}                                
                                >
                                    {darkMode ? <WbSunnyRoundedIcon /> : <ModeNightRoundedIcon />}
                                </IconButton>
                            </Tooltip>} */}
                            {getDeviceType() ==='mobile' &&  hasNotificacao && 
                                <NotificationComp/>}
                            <MySpaceComp/>

                        </Box>

                    </Toolbar>
                    {/* <EditarPaginaHtml open={openEditar} setOpen={setOpenEditar} doAction={handelDoAction} pagina={pagina} /> */}
                    <LayoutLeft openD={openD} setOpenD={setOpenD} pageRoot={pageRoot} />
                </AppBar>
            </Box>
        )
    }
    return (
        <p>Não implementado {bloco.type}</p>
    )
}